// removed by extract-text-webpack-plugin
module.exports = {"LoginOIDC":"_1iYEazcrj8SqYAnuDUoKUq","LoginForm":"_2dtQ-PZZYMw5pUcJM8Al8b","version":"_22lycnNXb00S-M6cb5JwdI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/styles.css
// module id = 653
// module chunks = 0